<template>
  <BittsCollapse class="current-plan-collapse" title="Current Plan">
    <section
      v-if="platformFee && hasV5Subscription"
      data-testid="connector-plan"
    >
      <div>
        <span>Connector Platform Fee</span>
        <p>{{ platformFee }}/{{ billingPeriod }}</p>
      </div>
      <p>{{ platformFee }}</p>
    </section>
    <section data-testid="full-access">
      <div>
        <span
          >{{ totalBoughtCoreSeats }} x Connector Full Access
          {{ totalBoughtCoreSeats == 1 ? 'seat' : 'seats' }}</span
        >
        <p>{{ seatCost }} per seat/{{ billingPeriod }}</p>
      </div>
      <p>{{ totalSeatCost }}</p>
    </section>
    <section v-if="salesSeatLimit" data-testid="sales">
      <div>
        <span
          >{{ salesSeatLimit }} Sales
          {{ salesSeatLimit == 1 ? 'seat' : 'seats' }}</span
        >
        <p>{{ salesSeatCost }} per seat/{{ billingPeriod }}</p>
      </div>
      <p>{{ totalSalesSeatCost }}</p>
    </section>
  </BittsCollapse>
</template>

<script setup lang="ts">
import { BittsCollapse } from '@crossbeam/bitts';

import { computed } from 'vue';

const {
  billingPeriod,
  coreSeatLimit,
  hasV5Subscription,
  platformFee,
  salesSeatLimit,
  salesSeatCost,
  seatCost,
  totalSeatCost,
  totalSalesSeatCost,
} = defineProps<{
  billingPeriod: string;
  coreSeatLimit: number;
  salesSeatLimit?: number;
  hasV5Subscription?: boolean;
  platformFee: string;
  seatCost: string;
  salesSeatCost?: string;
  totalSeatCost: string;
  totalSalesSeatCost?: string;
}>();

const totalBoughtCoreSeats = computed(() => {
  return coreSeatLimit;
});
</script>

<style scoped lang="pcss">
@reference "../../css/theme.css";
.current-plan-collapse {
  @apply rounded-bts-md bg-white p-12;
}
section {
  @apply flex justify-between items-start py-16 border-b border-solid border-neutral-border;
  &:last-of-type {
    @apply border-none pb-4;
  }
}
span {
  @apply text-neutral-text-strong;
}
p {
  @apply text-neutral-text-weak;
}
</style>
